import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { updateWealthAccounts } from '../actions';
import { selectTradingAccount } from '../reducers/selectors';
const useAccount = (options) => {
    const dispatch = useAppDispatch();
    const account = useAppSelector(selectTradingAccount);
    useEffect(() => {
        if (options?.refresh) {
            dispatch(updateWealthAccounts({ skipGetPositions: options.skipGetPositions }));
        }
    }, []);
    return account.account;
};
export default useAccount;
